import { post, get } from 'src/tools/server';
const getInventorySetting = (uuid) => {
  return get<any>(`/portal/setting/salesChannel/inventorySetting/${uuid}`, {});
};
const postInventorySetting = (uuid, body): Promise<any> => {
  return post<any>(
    `/portal/setting/salesChannel/inventorySetting/${uuid}`,
    body,
    {},
  );
};
export { getInventorySetting, postInventorySetting };
